import { ReactNode } from "react";
import { Modal } from "antd";
import modalSideIcon from "assets/svg/modalSideIcon.svg";
import cancelIcon from "assets/svg/cancelIcon.svg";
import "./wrapper-style.scss";

export const ModalWrapper = ({
  children,
  open,
  onCancel,
  icon,
  headerText,
  large,
  medium,
  noHeader,
}: {
  children: ReactNode;
  open: boolean;
  onCancel: () => void;
  icon?: string;
  headerText?: string;
  large?: boolean;
  medium?: boolean;
  noHeader?: boolean;
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={null}
      centered
      closeIcon={false}
      {...(large ? { width: 1200 } : medium ? { width: 700 } : {})}
      className=""
    >
      {!noHeader && (
        <div className="flex items-center justify-between">
          <span className={"flex items-center gap-2"}>
            <img src={icon ? icon : modalSideIcon} alt={""} />
            {headerText && (
              <p className={"text-lg font-sfRegular"}>{headerText}</p>
            )}
          </span>
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg p-2 hover:bg-[#F5F5F5] transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6929]"
          >
            <img src={cancelIcon} alt={"Cancel Icon"} />
          </button>
        </div>
      )}

      <div className="mt-3 ">{children}</div>
    </Modal>
  );
};

export const EditorModalWrapper = ({
  children,
  open,
  onCancel,
  icon,
  headerText,
  large,
  medium,
  noHeader,
  fullScreen,
}: {
  children: ReactNode;
  open: boolean;
  onCancel: () => void;
  icon?: string;
  headerText?: string;
  large?: boolean;
  medium?: boolean;
  noHeader?: boolean;
  fullScreen?: boolean;
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={null}
      centered={!fullScreen}
      closeIcon={false}
      {...(fullScreen
        ? {
            width: "100vw",
            style: {
              top: 0,
              paddingBottom: 0,
              maxWidth: "none",
            },
            body: {
              height: "100vh",
              padding: fullScreen ? "20px" : undefined,
            },
          }
        : large
        ? { width: 1200 }
        : medium
        ? { width: 828 }
        : {})}
      className={fullScreen ? "fullscreen-modal" : ""}
    >
      {!noHeader && (
        <div className="w-full">
          <div className="flex items-center justify-between mb-3">
            <span className={"flex items-center gap-2"}>
              {/* <img src={icon ? icon : modalSideIcon} alt={""} /> */}
              {headerText && (
                <p className={"text-xl font-sfRegular"}>{headerText}</p>
              )}
            </span>
            <button
              onClick={onCancel}
              className="h-8 px-[10px] bg-black text-white rounded-md"
            >
              {/* <img src={cancelIcon} alt={"Cancel Icon"} /> */}
              Save description & close
            </button>
          </div>
          <hr className="w-full " />
        </div>
      )}

      <div className={`${fullScreen ? "h-full overflow-auto" : "mt-3"}`}>
        {children}
      </div>
    </Modal>
  );
};
